import { render, staticRenderFns } from "./InsuranceAction.vue?vue&type=template&id=49741ca1"
import script from "./InsuranceAction.vue?vue&type=script&lang=js"
export * from "./InsuranceAction.vue?vue&type=script&lang=js"
import style0 from "./InsuranceAction.vue?vue&type=style&index=0&id=49741ca1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports